(function () {
  const hero = document.querySelector('[data-nr-home-hero]');
  if (!hero) return;

  const wordEl = hero.querySelector('[data-nr-changing-word]');
  const linkEl = hero.querySelector('[data-nr-word-link]');

  if (!wordEl || !linkEl) return;

  const suffixes = ['', ' parties', ' shop', ' interviews'];
  const links = ['/', '/pages/party', '/collections/shop-all', '/pages/interview'];
  const zoneIndex = {
    landing: 0,
    parties: 1,
    shop: 2,
    interviews: 3,
  };

  const DELETE_MS = 50;
  const TYPE_MS = 80;
  const ZONE_DEBOUNCE_MS = 120;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let currentIndex = 0;
  let activeInterval = null;
  let zoneDebounceTimer = null;
  const zoneVisibility = new Map();

  function clearTyping() {
    if (activeInterval !== null) {
      window.clearInterval(activeInterval);
      activeInterval = null;
    }
  }

  function setSuffix(index) {
    wordEl.textContent = suffixes[index];
    currentIndex = index;
    linkEl.setAttribute('href', links[index]);
  }

  function deleteSuffix(suffix, callback) {
    let length = suffix.length;

    activeInterval = window.setInterval(function () {
      if (length > 0) {
        wordEl.textContent = suffix.substring(0, length - 1);
        length -= 1;
      } else {
        clearTyping();
        if (callback) callback();
      }
    }, DELETE_MS);
  }

  function typeSuffix(suffix, callback) {
    let length = 0;

    activeInterval = window.setInterval(function () {
      if (length < suffix.length) {
        length += 1;
        wordEl.textContent = suffix.substring(0, length);
      } else {
        clearTyping();
        if (callback) callback();
      }
    }, TYPE_MS);
  }

  function getActiveZoneIndex() {
    let bestZone = 'landing';
    let bestRatio = -1;

    zoneVisibility.forEach(function (ratio, zone) {
      if (ratio > bestRatio) {
        bestRatio = ratio;
        bestZone = zone;
      }
    });

    return zoneIndex[bestZone] ?? 0;
  }

  function updateWordmarkVisibility() {
    const onLanding = getActiveZoneIndex() === 0;

    if (onLanding) {
      hero.classList.add('nr-home-hero--hide-wordmark');
    } else {
      hero.classList.remove('nr-home-hero--hide-wordmark');
    }
  }

  function goToIndex(index) {
    if (index === 0) {
      clearTyping();
      setSuffix(0);
      updateWordmarkVisibility();
      return;
    }

    updateWordmarkVisibility();

    if (index === currentIndex && !activeInterval) {
      linkEl.setAttribute('href', links[index]);
      return;
    }

    if (prefersReducedMotion) {
      clearTyping();
      setSuffix(index);
      return;
    }

    const targetSuffix = suffixes[index];
    const fromLanding = currentIndex === 0;
    const currentSuffix = fromLanding ? '' : wordEl.textContent;

    clearTyping();

    if (!fromLanding && currentSuffix === targetSuffix) {
      currentIndex = index;
      linkEl.setAttribute('href', links[index]);
      return;
    }

    function complete() {
      currentIndex = index;
      linkEl.setAttribute('href', links[index]);
    }

    if (fromLanding) {
      wordEl.textContent = '';
      typeSuffix(targetSuffix, complete);
      return;
    }

    deleteSuffix(currentSuffix, function () {
      typeSuffix(targetSuffix, complete);
    });
  }

  function scheduleGoToIndex(index) {
    if (zoneDebounceTimer !== null) {
      window.clearTimeout(zoneDebounceTimer);
    }

    zoneDebounceTimer = window.setTimeout(function () {
      zoneDebounceTimer = null;
      goToIndex(index);
    }, ZONE_DEBOUNCE_MS);
  }

  function updateFadeOut() {
    const footers = document.querySelectorAll('.nr-footer, .nr-footer-gallery, .nr-footer-panel, .nr-footer-bar');
    if (!footers.length) {
      hero.classList.remove('fade-out');
      return;
    }

    let lowestTop = Infinity;
    footers.forEach(function (footer) {
      const top = footer.getBoundingClientRect().top;
      if (top < lowestTop) lowestTop = top;
    });

    const footerInView = lowestTop < window.innerHeight * 0.85;

    if (footerInView) {
      hero.classList.add('fade-out');
    } else {
      hero.classList.remove('fade-out');
    }
  }

  function handleScrollUI() {
    updateFadeOut();
    updateWordmarkVisibility();
  }

  function handleZoneChange() {
    scheduleGoToIndex(getActiveZoneIndex());
    updateWordmarkVisibility();
  }

  const zones = document.querySelectorAll('[data-nr-scroll-zone]');
  if (zones.length) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const zone = entry.target.getAttribute('data-nr-scroll-zone');
          if (zone) {
            zoneVisibility.set(zone, entry.intersectionRatio);
          }
        });
        handleZoneChange();
      },
      {
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    );

    zones.forEach(function (zone) {
      zoneVisibility.set(zone.getAttribute('data-nr-scroll-zone'), 0);
      observer.observe(zone);
    });
  }

  let ticking = false;
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        handleScrollUI();
        ticking = false;
      });
      ticking = true;
    }
  });

  linkEl.setAttribute('href', links[0]);
  wordEl.textContent = '';
  handleScrollUI();
})();
